import React from 'react'
import NavBar from '../components/NavBar'
import UserProfile from '../components/UserProfile'
import Footer from '../components/Footer'

const QrDetailsPage = () => {
    return (
        <div className='min-h-screen flex flex-col'>

            <NavBar />
            <UserProfile />
            <Footer />
        </div>
    )
}

export default QrDetailsPage